import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cx from "classnames";
import styles from "./favourites.module.css";
import { useContext } from "react";
import { SharedUiHeaderV2Context } from "../../context/context-shared-ui-header-v2";
import { SvgIcon } from "@cinch-labs/design-system";
export const Favourites = ()=>{
    const { logicStore , userStore  } = useContext(SharedUiHeaderV2Context);
    const { favourites  } = userStore;
    const favouritesAmount = (favourites === null || favourites === void 0 ? void 0 : favourites.length) ?? 0;
    const { handleTrackEvent  } = logicStore;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.link,
        children: /*#__PURE__*/ _jsxs("a", {
            href: "/my-profile/favourites",
            "aria-label": "View your favourites",
            onClick: ()=>handleTrackEvent({
                    name: "click",
                    category: "mega menu",
                    label: "saved favourites",
                    action: "button"
                }),
            "data-testid": "Favourites/Anchor",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.svg,
                    children: /*#__PURE__*/ _jsx(SvgIcon, {
                        name: "heart",
                        height: 14
                    })
                }),
                favouritesAmount > 0 && /*#__PURE__*/ _jsx("span", {
                    "data-testid": "Favourites/Amount",
                    className: cx(styles.number, styles.pulse),
                    children: favouritesAmount
                })
            ]
        })
    });
};
